// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__KX17u","tuyaListBody":"tuyaListBody__h+7WP"};